import {
  Arrow, Camera, Microphone, Text,
} from '@myinterview/component-library';
import classNames from 'classnames';
import React, { useState } from 'react';
import { mediaDeviceType } from '../interfaces/recorderInterface';

export interface IDeviceSelectorList {
  deviceList: MediaDeviceInfo[],
  selectedDevice?: MediaDeviceInfo,
  onDeviceSelected: (type: mediaDeviceType, deviceId: string) => void,
  deviceType: mediaDeviceType,
}

export const DeviceSelectorList:React.FC<IDeviceSelectorList> = ({
  deviceList, selectedDevice, onDeviceSelected, deviceType,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const arrowClassNames = classNames({
    'myinterview-widget-device__arrow': true,
    'myinterview-widget-device__arrow--open': isOpen,
  });

  const listClassNames = classNames({
    'myinterview-widget-device__select-list': true,
    'myinterview-widget-scroll-indicator': deviceList.length > 2,
    'myinterview-widget-device__select-list--open': isOpen,
  });

  return (
    <div className="myinterview-widget-device__select-group">
      <div className="myinterview-widget-device__selected-device" onClick={() => setIsOpen((prev) => !prev)} role="presentation">
        <div className="myinterview-widget-device__select-icon">
          {deviceType === 'video' ? <Camera /> : <Microphone />}
        </div>
        <div className="myinterview-widget-device__selected-title-wrapper">
          <Text className="myinterview-widget-device__selected-title" size="S-Regular">{selectedDevice?.label || 'Select Device'}</Text>
        </div>
        <div className={arrowClassNames}><Arrow /></div>
      </div>
      <div className={listClassNames}>
        {deviceList?.map((device) => (
          <Text
            key={device.deviceId}
            className={`
                myinterview-widget-device__select-option
                ${device.deviceId === selectedDevice?.deviceId ? 'myinterview-widget-device__select-option--selected' : ''
            }`}
            size="S-Regular"
            onClick={() => onDeviceSelected(deviceType, device.deviceId)}
          >
            {device.label}
          </Text>
        ))}
      </div>
    </div>
  );
};
